import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Accordion,
  Checkbox,
  ContainerCheckbox,
} from './styles';

import TranscriptTimeOnTask from './transcript-time-on-task';

const SelectQuestion = (props) => {
  const {
    question,
    active,
    answer,
    onSubmit,
    onRemoveTagHighlight,
    timeOnTask,
  } = props;

  return (
    <Accordion.Content
      active={active}
      key={question.id + question.groupId}
    >

      <ContainerCheckbox>
        {question.questionOptions.map((option) => (
          <Checkbox
            key={option.id}
            label={option.label}
            disabled
            checked={_.find(answer.questionOptions, (answerOption) => answerOption.id === option.id)}
            radio={question.questionType === 'single_select'}
          />
        ))}

      </ContainerCheckbox>

      <TranscriptTimeOnTask
        answer={answer}
        timeOnTask={timeOnTask}
        onSubmit={(value) => onSubmit(value, answer.id)}
        onRemoveTagHighlight={onRemoveTagHighlight}
      />
    </Accordion.Content>
  );
};

SelectQuestion.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    groupId: PropTypes.string.isRequired,
    questionType: PropTypes.string,
    questionOptions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
    })),
  }).isRequired,
  answer: PropTypes.shape({
    id: PropTypes.string,
    questionOptions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
    })),
  }).isRequired,
  active: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onRemoveTagHighlight: PropTypes.func.isRequired,
  timeOnTask: PropTypes.node.isRequired,
};

SelectQuestion.defaultProps = {
  active: false,
};

export default SelectQuestion;
